import { useEffect, FunctionComponent } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/AppContainer/messages';
import { translate } from 'containers/services/translate';
import Divider from '@material-ui/core/Divider';
import { get, isEmpty, isNil } from 'lodash';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import Inboxe from 'containers/AppContainer/Inboxes/Inboxe';
import { CICA_MIXTE_INBOXES } from 'containers/AppContainer/AppBar/constants';
import { getTransactionArea } from 'containers/AppContainer/utils';
import {
  BinDiv,
  DrawerContainer,
  DrawerDiv,
} from 'containers/AppContainer/AppBar/style';
import {
  getMaxNotificationTime,
  renderNotifications,
  getCountNotifications,
  getInboxesId,
  getTransactionInboxes,
} from 'containers/AppContainer/AppBar/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import userPrivelges from 'containers/services/security/user-privileges';
export interface InboxesDrawerProps {
  intl: IntlShape;
  isDrawerOpen: boolean;
  loaders: any;
  setIsDrawerOpen: Function;
  listings: any;
  expandRow: any;
  setExpandRow: any;
  managerNotifications: any;
  handleClickNotificationInboxe: Function;
  openingManagerNotificationsMixedClaim: any;
  requestGetNotificationsInboxes: Function;
}
const InboxesDrawer: FunctionComponent<InboxesDrawerProps> = ({
  ...props
}): JSX.Element => {
  const handleToggleDrawer = () => {
    props.setIsDrawerOpen(!props.isDrawerOpen);
  };
  const { userInboxesId, transactionInboxeAreaId } = getInboxesId();
  useEffect(() => {
    const inboxes = userPrivelges
      .getUserInboxes()
      .map((el: any) => el.managerInboxesId);
    if (props.isDrawerOpen) {
      props.requestGetNotificationsInboxes({
        inboxes,
        transactionAreaInboxes: getTransactionInboxes(),
        isPriorityClaimManager: userPrivileges.userHasPrivilege(
          PRIVILEGES.ISPRIORITYCLAIMSMANAGER,
        ),
      });
    }
  }, [props.isDrawerOpen]);

  const convertionInboxe = userPrivelges
    .getUserInboxes()
    .find((el: any) => el.managerInboxe.title === CICA_MIXTE_INBOXES);
  return (
    <DrawerContainer
      anchor="right"
      open={props.isDrawerOpen}
      onClose={handleToggleDrawer}
    >
      <DrawerDiv>
        <div className="titleConatainer">
          <span className="title">
            {translate({ ...messages.inboxesDrawerTitle }, props)}
          </span>

          <ClearOutlinedIcon
            data-testid={'close-icon'}
            onClick={handleToggleDrawer}
          />
        </div>
        <Divider className="divider" />
        <div className="content">
          <BinDiv>
            {!isEmpty(userPrivelges.getUserInboxes()) &&
              userPrivelges
                .getUserInboxes()
                ?.map(
                  (
                    element: {
                      managerInboxe: { title: string; id: number; sla: number };
                      transactionInboxeAreaId: number;
                    },
                    index: number,
                  ) => (
                    <Inboxe
                      title={
                        element.managerInboxe.title +
                        getTransactionArea(
                          element.transactionInboxeAreaId,
                          props.listings,
                        )
                      }
                      sla={element.managerInboxe.sla}
                      loaders={props.loaders}
                      count={getCountNotifications(
                        props.managerNotifications,
                        element,
                      )}
                      index={index}
                      expandRow={props.expandRow}
                      setExpandRow={props.setExpandRow}
                      managerNotifications={renderNotifications(
                        props.managerNotifications,
                        convertionInboxe,
                        userInboxesId,
                        transactionInboxeAreaId,
                      )}
                      managerInboxesId={
                        !isNil(get(element, 'transactionInboxeAreaId', null))
                          ? get(element, 'transactionInboxeAreaId')
                          : get(element, 'managerInboxe.id')
                      }
                      handleClickNotificationInboxe={
                        props.handleClickNotificationInboxe
                      }
                      maxNotification={getMaxNotificationTime(
                        props.managerNotifications,
                        convertionInboxe,
                        element,
                      )}
                    />
                  ),
                )}
          </BinDiv>
        </div>
      </DrawerDiv>
    </DrawerContainer>
  );
};

export default injectIntl(InboxesDrawer);
